import i18n from 'i18next';
import * as URI from 'uri-js';

import { CausedError, NameResolvingError, NodeApiError, NodeConnectionError, VerboseError } from "api";
import { Storage } from "storage";
import { errorDismiss, errorShow, ErrorThrownAction } from "state/error/actions";
import { jumpNear } from "state/navigation/actions";
import { messageBox } from "state/messagebox/actions";
import { getHomeRootLocation } from "state/home/selectors";
import { saga } from "state/saga";
import { dispatch, select } from "state/store-sagas";
import * as Browser from "ui/browser";
import { delay } from "util/misc";

export default [
    saga("ERROR_THROWN", "", errorThrownSaga),
    saga("ERROR_AUTH_INVALID", "", errorAuthInvalidSaga)
];

async function errorThrownSaga(action: ErrorThrownAction): Promise<void> {
    const err = action.payload.e;
    if (err instanceof NodeApiError && !err.errorCode.startsWith("carte.")) {
        return;
    }

    let message: string | null = null;
    let messageVerbose: string | null = null;

    if (err instanceof Error) {
        message = err.message;
    }
    if (!message) {
        message = err.toString();
    }
    console.error(message);

    if (err instanceof VerboseError) {
        messageVerbose = err.messageVerbose;
    }
    if (messageVerbose) {
        console.error(messageVerbose);
    }

    if (err instanceof CausedError) {
        for (let cause = err.cause; cause != null; cause = cause.cause) {
            const causedBy = `Caused by ${cause.type}`;
            messageVerbose = messageVerbose != null ? messageVerbose + "\n" + causedBy : causedBy;
            console.error(causedBy, cause);
        }
    }

    if (document.visibilityState !== "visible") {
        return;
    }
    if (err instanceof NodeConnectionError || err instanceof NameResolvingError || err instanceof NodeApiError) {
        return;
    }

    await delay(1000);
    dispatch(errorShow(message ?? "", messageVerbose));
    await delay(10000);
    dispatch(errorDismiss());
}

function errorAuthInvalidSaga(): void {
    const location = select(getHomeRootLocation);
    if (location != null) {
        Storage.deleteData(location);
        const {path = null, query = null} = URI.parse(Browser.urlWithBackHref("/connect"));
        dispatch(messageBox(i18n.t("disconnected-from-home"), jumpNear(path, query, null)));
    }
}
